import { gql } from '@apollo/client';
import { DealHeaderFragment } from '../fragments/DealHeaderFragment';
/**
 * @const UpdateDealHeaderMutation
 * @since 1.0.0
 */
export const UpdateDealHeaderMutation = gql `
  mutation UpdateDealHeaderMutation($input: UpdateDealInput!) {
    updateDeal(input: $input) {
      ...DealHeaderFragment
    }
  }

  ${DealHeaderFragment}
`;
